import React, { ReactNode } from "react";
import "./LearningPage.css";

type LearningPageParentProps = {
  readonly children: ReactNode;
  readonly title?: string;
};

export default function LearningPageParent({
  children,
  title = "For Teachers & Parents",
}: LearningPageParentProps) {
  return (
    <aside className="learning-parent">
      <h2 className="learning-parent-title">{title}</h2>
      <div className="learning-parent-inner">{children}</div>
    </aside>
  );
}
